var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.25,
    stroke: "#3B82F6",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6154 8.31351H7.49997C6.87546 8.31351 6.3692 8.74335 6.3692 9.27359V15.328C6.3692 15.8583 6.87546 16.2881 7.49997 16.2881H12.6154C13.2399 16.2881 13.7461 15.8583 13.7461 15.328V9.27359C13.7461 8.74335 13.2399 8.31351 12.6154 8.31351Z",
    stroke: "#3B82F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 8.31351H17.1C16.4755 8.31351 15.9692 8.74335 15.9692 9.27359V15.328C15.9692 15.8583 16.4755 16.2881 17.1 16.2881H26.5C27.1245 16.2881 27.6308 15.8583 27.6308 15.328V9.27359C27.6308 8.74335 27.1245 8.31351 26.5 8.31351Z",
    stroke: "#3B82F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 18.7119H7.49997C6.87546 18.7119 6.3692 19.1418 6.3692 19.672V25.7264C6.3692 26.2567 6.87546 26.6865 7.49997 26.6865H16.9C17.5245 26.6865 18.0307 26.2567 18.0307 25.7264V19.672C18.0307 19.1418 17.5245 18.7119 16.9 18.7119Z",
    stroke: "#3B82F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 18.7119H21.3846C20.7601 18.7119 20.2538 19.1418 20.2538 19.672V25.7264C20.2538 26.2567 20.7601 26.6865 21.3846 26.6865H26.5C27.1245 26.6865 27.6308 26.2567 27.6308 25.7264V19.672C27.6308 19.1418 27.1245 18.7119 26.5 18.7119Z",
    stroke: "#3B82F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white",
    transform: "translate(5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.dfb967e9730f538d7c7469868aeb5c7d.svg";
export { ForwardRef as ReactComponent };